import { useMutation, useQueryClient } from '@tanstack/react-query';
import { shopsService } from '../services/shops.service';
import type { CreateShopData } from '../types/shops.types';

interface CreateShopInput {
  data: CreateShopData;
  images: File[];
}

export function useCreateShop() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ data, images }: CreateShopInput) => shopsService.createShop(data, images),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['shops'] });
    },
  });
}
